"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2413],{

/***/ 20932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ A; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: ",
        ";\n          text-decoration: ",
        ";\n          &:hover {\n            text-decoration: underline;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var A = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Anchor(props, ref) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), props.color || plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, props.decoration || "underline"),
        ref: ref,
        "data-test-id": props.dataTestId
    }, props));
});


/***/ }),

/***/ 70516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JG": function() { return /* binding */ getPartnerships; },
/* harmony export */   "Kx": function() { return /* binding */ getInvestorLink; },
/* harmony export */   "Lj": function() { return /* binding */ getExternalNews; },
/* harmony export */   "Lx": function() { return /* binding */ getDetailsLp; },
/* harmony export */   "NE": function() { return /* binding */ fetchInvestors; },
/* harmony export */   "Ny": function() { return /* binding */ getDetailsCurrent; },
/* harmony export */   "OV": function() { return /* binding */ getDetailsIpo; },
/* harmony export */   "Qi": function() { return /* binding */ getInvestorFunds; },
/* harmony export */   "RL": function() { return /* binding */ getInvestorFund; },
/* harmony export */   "Tj": function() { return /* binding */ getInvestorOverseasCompanies; },
/* harmony export */   "YG": function() { return /* binding */ getDetailsLeading; },
/* harmony export */   "be": function() { return /* binding */ getAcquisitions; },
/* harmony export */   "dc": function() { return /* binding */ downloadInvestorCompanies; },
/* harmony export */   "ej": function() { return /* binding */ getDetailsPast; },
/* harmony export */   "jM": function() { return /* binding */ fetchInvestorSummary; },
/* harmony export */   "kH": function() { return /* binding */ getPeople; },
/* harmony export */   "mx": function() { return /* binding */ getInvestorFull; },
/* harmony export */   "p1": function() { return /* binding */ getInvestorLpDetail; },
/* harmony export */   "uc": function() { return /* binding */ getSeedFunded; },
/* harmony export */   "wu": function() { return /* binding */ getInvestorCompanies; },
/* harmony export */   "xX": function() { return /* binding */ getFinanceNews; }
/* harmony export */ });
/* unused harmony exports getCapitalist, getCvcPeople, followInvestor, unfollowInvestor, getInvestorFollowing */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6140);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79240);






var fetchInvestors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(condition, fetchApi) {
        var formattedCondition, ref, result, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    formattedCondition = {
                        limit: condition.limit,
                        offset: condition.offset
                    };
                    if (condition.keywords.length > 0) {
                        formattedCondition.keywords = condition.keywords;
                    }
                    if (condition.categories.length > 0) {
                        ;
                        formattedCondition.categories = (ref = condition.categories) === null || ref === void 0 ? void 0 : ref.map(function(v) {
                            if (v.subCategories.length !== 0) {
                                return v.name + ":" + v.subCategories.join("_");
                            } else {
                                return v.name;
                            }
                        }).join(",");
                    }
                    if (condition.countries.length > 0) {
                        formattedCondition.countries = condition.countries.join(",");
                    }
                    if (condition.industries.length > 0) {
                        formattedCondition.industries = condition.industries.join(",");
                    }
                    return [
                        4,
                        getInvestors(formattedCondition, fetchApi)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        {
                            data: result.data || [],
                            count: result.count || 0,
                            master: result.master || {
                                categories: []
                            }
                        }
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {
                            data: [],
                            count: 0,
                            master: {
                                categories: []
                            }
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchInvestors(condition, fetchApi) {
        return _ref.apply(this, arguments);
    };
}();
var fetchInvestorSummary = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, shortname) {
        var res, statusCode, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getInvestorSummary(ctx, shortname)
                    ];
                case 1:
                    res = _state.sent();
                    statusCode = res.status;
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(e.response, Response)) {
                        statusCode = e.response.status;
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        {
                            data: res === null || res === void 0 ? void 0 : res.data,
                            status: statusCode
                        }
                    ];
            }
        });
    });
    return function fetchInvestorSummary(ctx, shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(condition, fetchApi) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                fetchApi("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors?").concat(query_string__WEBPACK_IMPORTED_MODULE_1__.stringify(condition)))
            ];
        });
    });
    return function getInvestors(condition, fetchApi) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorSummary = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/investors/").concat(shortname, "/summary"))
            ];
        });
    });
    return function getInvestorSummary(ctx, shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorFull = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/investors/").concat(shortname))
            ];
        });
    });
    return function getInvestorFull(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorLink = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname))
            ];
        });
    });
    return function getInvestorLink(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/companies?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getInvestorCompanies(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorOverseasCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(globalId, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(globalId, "/overseas_companies?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getInvestorOverseasCompanies(globalId, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var downloadInvestorCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, format) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIRaw */ .RH)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/companies.").concat(format), {
                    method: "GET",
                    credentials: "include"
                })
            ];
        });
    });
    return function downloadInvestorCompanies(shortname, format) {
        return _ref.apply(this, arguments);
    };
}();
var getSeedFunded = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/companies-seed?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getSeedFunded(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getAcquisitions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/companies-acquisition?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getAcquisitions(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getPartnerships = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/companies-partnership?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getPartnerships(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorFunds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/funds?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getInvestorFunds(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailsCurrent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/investments-current?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getDetailsCurrent(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailsPast = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/investments-past?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getDetailsPast(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailsLeading = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/investments-leading?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getDetailsLeading(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailsIpo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/investments-ipo?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getDetailsIpo(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailsLp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/investments-lp?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getDetailsLp(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getPeople = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(type, shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                type === "vc" ? getCapitalist(shortname, limit, offset) : type === "cvc" ? getCvcPeople(shortname, limit, offset) : undefined
            ];
        });
    });
    return function getPeople(type, shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getCapitalist = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/people-capitalist?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getCapitalist(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getCvcPeople = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/people-cvc?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getCvcPeople(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getFinanceNews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/news-finance?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getFinanceNews(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var getExternalNews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, limit, offset) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/news-external?limit=").concat(limit, "&offset=").concat(offset))
            ];
        });
    });
    return function getExternalNews(shortname, limit, offset) {
        return _ref.apply(this, arguments);
    };
}();
var followInvestor = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/follow"), {
                    method: "POST",
                    credentials: "include"
                })
            ];
        });
    });
    return function followInvestor(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var unfollowInvestor = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/unfollow"), {
                    method: "POST",
                    credentials: "include"
                })
            ];
        });
    });
    return function unfollowInvestor(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorFollowing = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(shortname, "/following"))
            ];
        });
    });
    return function getInvestorFollowing(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorFund = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(investorShortname, fundShortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(investorShortname, "/funds/").concat(fundShortname))
            ];
        });
    });
    return function getInvestorFund(investorShortname, fundShortname) {
        return _ref.apply(this, arguments);
    };
}();
var getInvestorLpDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(investorShortname, lpDetailShortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/investors/").concat(investorShortname, "/lp-details/").concat(lpDetailShortname))
            ];
        });
    });
    return function getInvestorLpDetail(investorShortname, lpDetailShortname) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 61753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33431);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56902);
/* harmony import */ var _lib_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11543);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18584);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96747);













var Error = function(param) {
    var _statusCode = param.statusCode, statusCode = _statusCode === void 0 ? 404 : _statusCode, err = param.err;
    var msg = msgOf(statusCode);
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var errorMessage = "".concat(err === null || err === void 0 ? void 0 : err.name, " ").concat(err === null || err === void 0 ? void 0 : err.message);
        console.log("error", errorMessage);
        (0,_lib_gtm__WEBPACK_IMPORTED_MODULE_5__/* .pushEventToGTM */ .K)(user, _lib_tracking__WEBPACK_IMPORTED_MODULE_4__/* .ERROR */ .pn, errorMessage);
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_common_Template__WEBPACK_IMPORTED_MODULE_1__/* .Template */ .Y, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("text-align:center;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30, ";padding:0 15px;"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    id: "error-page-error-code",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:100px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.statusCodeForDisplay
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:28px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.title
                }),
                msg.image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("img", {
                    src: msg.image,
                    alt: "Error Image",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-top:64px;}width:240px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{width:320px;}")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:16px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{font-size:18px;}"),
                    "data-test-id": "error-page-description",
                    children: msg.description
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("a", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;margin-bottom:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-bottom:64px;}display:flex;align-items:center;justify-content:center;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__/* .IcomoonIcon */ .g, {
                                name: "arrow-back",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;padding-right:4px;")
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;"),
                                children: "トップに戻る"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var msgOf = function(statusCode) {
    switch(statusCode){
        case 403:
            return {
                title: "FORBIDDEN",
                description: "このページへのアクセスは禁止されています。"
            };
        case 404:
            return {
                image: "/static/images/error/illust-404.png",
                description: "お探しのページは見つかりませんでした。"
            };
        case 500:
        default:
            return {
                statusCodeForDisplay: 500,
                title: "INTERNAL SERVER ERROR"
            };
    }
};
var handleTrailingSlash = function(req, res) {
    if (req.url) {
        var urlParts = req.url.split("?");
        if (urlParts[0].endsWith("/")) {
            urlParts[0] = urlParts[0].substring(0, urlParts[0].length - 1);
            res.writeHead(301, {
                Location: urlParts.join("?")
            });
            res.end();
        }
    }
};
Error.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(ctx) {
        var req, res, err, statusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            req = ctx.req, res = ctx.res, err = ctx.err;
            statusCode = res ? res.statusCode : err ? err.statusCode : 404;
            if (statusCode === 404 && req && res) {
                handleTrailingSlash(req, res);
            }
            if (res) {
                // Running on the server
                if (statusCode === 404) {
                    return [
                        2,
                        {
                            statusCode: 404
                        }
                    ];
                }
            }
            return [
                2,
                {
                    statusCode: statusCode,
                    err: err
                }
            ];
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ })

}]);